import type { FunctionComponent } from 'react'
import React, { useContext } from 'react'

import { PillButtonPage } from '../../../../../shared/pages/PillButtonPage'
import { ToolContext } from '../../../../../shared/state/appContext'
import globalStyles from '../../../../../shared/styles/GlobalStyles.module.scss'
import { trackAppointmentBookingSelection } from '../../../../../shared/utils/tracking/tracking'
import { HolidayBookingFlow, HolidayQueryFlow, LimitedOptionsFlow } from '../../../pageFlowData'
import { holidayQueryData } from './data'

export const HolidayQuery: FunctionComponent = () => {
  const { state, dispatch } = useContext(ToolContext)
  const {
    holiday: { holidayQuery },
    triage: { type },
  } = state

  const handleTracking = (id: string, index: number) => {
    trackAppointmentBookingSelection(type, HolidayQueryFlow.VIEW_NAME, { id, index })
  }

  const chooseStep = (id: string) => {
    switch (id) {
      case 'timeshares-pre':
        return LimitedOptionsFlow
      default:
        return HolidayBookingFlow
    }
  }

  const handleDispatch = (id: string) => {
    dispatch({ type: 'UPDATE_HOLIDAY_QUERY', data: id })
    const step = chooseStep(id)
    dispatch({ type: 'UPDATE_STEP', data: step.STEP })
    dispatch({ type: 'UPDATE_PROGRESS_VALUE', data: step.PROGRESS_VALUE })
  }

  const handleSubmit = (id: string, index: number) => {
    handleTracking(id, index)
    handleDispatch(id)
  }

  const { buttons, imgObj, title } = holidayQueryData

  return (
    <div className={globalStyles.fullWidthButton}>
      <PillButtonPage
        buttons={buttons}
        defaultValue={holidayQuery ? holidayQuery : ''}
        handleSubmit={handleSubmit}
        imgObj={imgObj}
        title={title}
      />
    </div>
  )
}
